import {
    Avatar,
    Flex,
    Table,
    tableHeaderCellBehavior,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import { Badge, TriggerFlex } from "./SoldeAjustement";
import { Textbox24Filled } from "@fluentui/react-icons";
import SkeletonListAjustments from "../SkeletonListAjustments/SkeletonLeaveList";
import { useMediaQuery } from "react-responsive";

export const TableCellStyles = {
    comment: {
        maxWidth: "40px",
        cursor: "pointer",
    },
};

const HistoryList = ({ list, isLoading }) => {
    const isSmallScreen = useMediaQuery({
        query: `(max-width:515px)`,
    });
    return (
        <Table aria-label="table">
            <Table.Row header>
                <Table.Cell
                    truncateContent
                    content={isSmallScreen ? "Informations" : "Date"}
                    accessibility={tableHeaderCellBehavior}
                />
                <Table.Cell
                    truncateContent
                    content="Collaborateur"
                    accessibility={tableHeaderCellBehavior}
                    hidden={isSmallScreen}
                />
                <Table.Cell
                    truncateContent
                    content="Opération effectuée"
                    accessibility={tableHeaderCellBehavior}
                    hidden={isSmallScreen}
                />
                <Table.Cell
                    truncateContent
                    content="Type"
                    accessibility={tableHeaderCellBehavior}
                    hidden={isSmallScreen}
                />
                <Table.Cell
                    truncateContent
                    content="Durée"
                    accessibility={tableHeaderCellBehavior}
                    hidden={isSmallScreen}
                />
                <Table.Cell
                    truncateContent
                    content="Solde ajusté"
                    accessibility={tableHeaderCellBehavior}
                    hidden={isSmallScreen}
                />
                <Table.Cell
                    truncateContent
                    content=""
                    accessibility={tableHeaderCellBehavior}
                    styles={TableCellStyles.comment}
                    hidden={isSmallScreen}
                />
            </Table.Row>
            {isLoading && <SkeletonListAjustments />}
            {!isLoading &&
                list?.pages?.map((pages) => {
                    return pages?.histories?.map((el, i) => {
                        return (
                            <Table.Row
                                key={el?.id}
                                styles={{
                                    height: isSmallScreen
                                        ? "fit-content"
                                        : "48px",
                                    paddingBlock: isSmallScreen ? "8px" : "0",
                                }}
                            >
                                <Table.Cell
                                    truncateContent
                                    content={
                                        isSmallScreen ? (
                                            <Flex column>
                                                <Flex>
                                                    <Flex
                                                        gap="gap.small"
                                                        vAlign="center"
                                                    >
                                                        <Avatar
                                                            image={
                                                                el?.user?.avatar
                                                            }
                                                            name={
                                                                el?.user?.name
                                                            }
                                                            size={
                                                                isSmallScreen
                                                                    ? "small"
                                                                    : "medium"
                                                            }
                                                        />
                                                        <Text
                                                            content={
                                                                el?.user?.name
                                                            }
                                                        />
                                                    </Flex>
                                                </Flex>
                                                <Flex gap="gap.smaller">
                                                    <Text
                                                        content={"Date:"}
                                                        weight="semibold"
                                                    />
                                                    <Text content={el?.date} />
                                                </Flex>
                                                <Flex gap="gap.smaller">
                                                    <Text
                                                        content={"Opération:"}
                                                        weight="semibold"
                                                    />
                                                    <Text
                                                        content={el?.action}
                                                    />
                                                </Flex>
                                                <Flex gap="gap.smaller">
                                                    <Text
                                                        content={"Type:"}
                                                        weight="semibold"
                                                    />
                                                    <Text
                                                        content={el?.leave_type}
                                                    />
                                                </Flex>
                                                <Flex gap="gap.smaller">
                                                    <Text
                                                        content={"Durée:"}
                                                        weight="semibold"
                                                    />
                                                    {el?.change_value && (
                                                        <Badge
                                                            content={
                                                                el?.change_value
                                                            }
                                                        />
                                                    )}
                                                </Flex>
                                                <Flex gap="gap.smaller">
                                                    <Text
                                                        content={"Ajusté:"}
                                                        weight="semibold"
                                                    />
                                                    <Text
                                                        content={el?.new_value}
                                                    />
                                                </Flex>
                                                <Flex wrap gap="gap.smaller">
                                                    <Text
                                                        content={"Commentaire:"}
                                                        weight="semibold"
                                                    />
                                                    <Text
                                                        content={el?.comment}
                                                    />
                                                </Flex>
                                            </Flex>
                                        ) : (
                                            el?.date
                                        )
                                    }
                                />
                                <Table.Cell
                                    truncateContent
                                    content={
                                        <Flex gap="gap.small" vAlign="center">
                                            <Avatar
                                                image={el?.user?.avatar}
                                                name={el?.user?.name}
                                            />
                                            <Text content={el?.user?.name} />
                                        </Flex>
                                    }
                                    hidden={isSmallScreen}
                                />
                                <Table.Cell
                                    truncateContent
                                    content={el?.action}
                                    hidden={isSmallScreen}
                                />
                                <Table.Cell
                                    truncateContent
                                    content={el?.leave_type}
                                    hidden={isSmallScreen}
                                />
                                <Table.Cell
                                    truncateContent
                                    content={
                                        el?.change_value && (
                                            <Badge content={el?.change_value} />
                                        )
                                    }
                                    hidden={isSmallScreen}
                                />
                                <Table.Cell
                                    truncateContent
                                    content={el?.new_value}
                                    hidden={isSmallScreen}
                                />
                                <Table.Cell
                                    truncateContent
                                    content={
                                        el?.comment && (
                                            <Tooltip
                                                position="before"
                                                align="start"
                                                pointing
                                                subtle={false}
                                                unstable_pinned
                                                positionFixed
                                                content={
                                                    <Flex fill>
                                                        <Text
                                                            content={
                                                                el?.comment
                                                            }
                                                        />
                                                    </Flex>
                                                }
                                                trigger={
                                                    <TriggerFlex>
                                                        <Textbox24Filled color="var(--color-primary)" />
                                                    </TriggerFlex>
                                                }
                                            />
                                        )
                                    }
                                    styles={TableCellStyles.comment}
                                    hidden={isSmallScreen}
                                />
                            </Table.Row>
                        );
                    });
                })}
        </Table>
    );
};

export default HistoryList;
